// extracted by mini-css-extract-plugin
export default {"invalidTab":"style_invalidTab__aXdsz","invalidTabContent":"style_invalidTabContent__81zyy"};